module.exports = __webpack_public_path__ + "media/images/plans/plan-ceremony-ed4a814a91d56a07b77941190439a43b.png";